import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITimesPlayedInTournament } from '@fantaz/shared/data-access/api';
import {
  CasualTournamentDetails,
  CasualTournamentEntity,
  CurrentUser,
  EventSchedule,
} from '@fantaz/shared/data-access/models';
import {
  PassesFacade,
  PlayTournamentFacade,
} from '@fantaz/tournaments/data-access';
// !FIXME: remove circular dependency

// TODO:clean up this component

@Component({
  selector: 'fz-play-button',
  templateUrl: './play-button.component.html',
  styleUrls: ['./play-button.component.scss'],
})
export class PlayButtonComponent {
  @Input()
  tournament: CasualTournamentEntity | CasualTournamentDetails;

  @Input()
  playButtonText: string | null;

  @Input()
  passUuid: string | null;

  @Input()
  eventSchedule: EventSchedule;

  @Input()
  isLoggedIn?: boolean | null;

  @Input()
  currentUser?: CurrentUser | null | undefined;

  @Input()
  location?: boolean | null;

  @Input()
  locationLoaded?: boolean | null;

  @Input()
  passesLoaded?: boolean;

  @Input()
  timesPlayedInfo?: ITimesPlayedInTournament[];

  @Input()
  basic = false;

  @Output()
  clickPressed = new EventEmitter<void>();

  constructor(
    private passesFacade: PassesFacade,
    private playTournamentFacade: PlayTournamentFacade,
  ) {}

  get comingSoon(): boolean {
    return (this.tournament && this.tournament.comingSoon) || false;
  }

  get isCompleted(): boolean {
    return (
      ('isComplete' in this.tournament
        ? this.tournament && this.tournament.isComplete
        : this.tournament && this.tournament.isCompleted) || false
    );
  }

  getTitle(): string {
    if (!this.isCompleted && this.isFinished) {
      return `The tournament is not completed yet but it's expired since ${this.endTime?.toUTCString()}.`;
    }

    if (this.isCompleted) {
      return 'The tournament is completed.';
    }

    if (this.maximumEntriesReached) {
      return `This tournament allows ${
        this.correctTournament?.timesCanEnter as number
      } ${
        (this.correctTournament?.timesCanEnter as number) > 1
          ? 'entries'
          : 'entry'
      }. You have reached the limit of how many times you can play in this tournament`;
    }

    return 'Click to play the tournament';
  }

  get maximumEntriesReached(): boolean {
    return (
      Number(this.correctTournament?.timesCanEnter) -
        Number(this.correctTournament?.playInstanceCount) ===
      0
    );
  }

  get correctTournament(): ITimesPlayedInTournament | undefined {
    return this.timesPlayedInfo?.find(
      (played) =>
        played.eventInstanceUuid === this.tournament.eventInstanceUuid,
    );
  }

  get isFinished(): boolean {
    if (this.endTime) {
      return new Date(this.endTime).getTime() < new Date().getTime();
    }
    return false;
  }

  get endTime(): Date | undefined {
    if (this.tournament?.casualGameEndTime) {
      return new Date(this.tournament.casualGameEndTime as Date);
    }
    return undefined;
  }

  getTournamentPasses() {
    if (this.tournament && this.eventSchedule) {
      this.passesFacade.load({
        eventPrototypeUuid: this.tournament.uuid,
        eventScheduleUuid: this.eventSchedule.uuid,
        userId: this.currentUser?.user.uuid,
      });
    }
  }

  get tournamentEnded() {
    return (
      'isComplete' in this.tournament &&
      this.tournament &&
      this.tournament.ended
    );
  }

  get eventPrototypeUuid() {
    return 'isComplete' in this.tournament
      ? this.tournament && this.tournament.uuid
      : this.tournament && this.tournament.eventPrototypeUuid;
  }

  redirectToRoom() {
    window.location.href = `/tournaments/${
      this.eventSchedule.lifeExperience ? 'prizes' : 'cash'
    }/${this.tournament.url}/${
      this.eventSchedule.uuid || this.eventSchedule.eventScheduleUuid
    }#passesSection`;
  }

  onClick($event: Event) {
    $event.stopPropagation();

    if (this.basic === true) {
      this.clickPressed.emit();
      return;
    }
    // TODO: move logic to store service
    if (!this.comingSoon) {
      const tournament = { ...this.tournament } as CasualTournamentDetails;
      const eventSchedule = { ...this.eventSchedule } as EventSchedule;
      tournament.eventPrototypeUuid =
        tournament.eventPrototypeUuid ?? this.tournament.uuid;
      eventSchedule.eventScheduleUuid =
        eventSchedule.eventScheduleUuid ?? this.eventSchedule.uuid;
      this.playTournamentFacade.playTournament({
        openTournament: tournament,
        pass: this.passUuid,
        entryAmount: this.eventSchedule.entryAmount as number,
        eventSchedule: eventSchedule,
        game: this.tournament?.game,
        zboOnly: this.tournament?.zboOnly,
        eventCode: this.eventSchedule.toPlayNow?.eventCode,
      });
    }
  }

  disableClick(event: Event) {
    if (this.isDisabledToPlay()) {
      event.stopPropagation();
    }
  }

  isDisabledToPlay() {
    return (
      this.comingSoon ||
      this.eventSchedule.retired ||
      this.tournamentEnded ||
      this.isCompleted ||
      this.maximumEntriesReached ||
      (this.passesLoaded !== null &&
        this.passesLoaded !== undefined &&
        !this.passesLoaded &&
        this.isLoggedIn) ||
      this.isFinished
    );
  }
}
